import { t as StyledSvgIcon } from "./SvgIcon.styles-D2P4wvY9.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/feather/Chevron left.svg?react
const SvgChevronLeft = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	d: "M15 18L9 12L15 6",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));

//#endregion
//#region src/icons/ChevronLeftIcon.tsx
function ChevronLeftIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgChevronLeft,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { ChevronLeftIcon as t };
//# sourceMappingURL=ChevronLeftIcon-YBCLfTFP.js.map